'use client'

import { Box, HStack, Text } from '@chakra-ui/react'
import { TagData } from '@/lib/utils/tagColor.utils'

interface TagsSectionProps {
  tags: TagData[]
}

export function TagsSection({ tags }: TagsSectionProps) {
  return (
    <Box w="full" overflowX="hidden" px={4}>
      <HStack 
        gap={1} 
        flexWrap="wrap" 
      >
        {tags.map((tag, index) => (
          <Box
            key={`${tag.label}-${index}`}
            flexShrink={0}
            px={3}
            py={1.5}
            background={tag.bgColor}
            
            rounded="full"
            pointerEvents="none"
          >
            <Text fontSize="xs" color={tag.textColor} fontWeight="medium">{tag.label}</Text>
          </Box>
        ))}
      </HStack>
    </Box>
  )
}